import { AIMessage, HumanMessage, SystemMessage } from '@langchain/core/messages';
export const isAnthropicPromptModel = (model) => {
    return ['claude-3-haiku-20240307', 'claude-3-5-sonnet-20240620', 'claude-3-opus-20240229'].includes(model);
};
export const isBedrockPromptModel = (model) => {
    return model.startsWith('eu.anthropic.');
};
export const isStreamingSupported = (model) => {
    return !['o1-mini'].includes(model);
};
export const isOutputPredictionSupported = (model) => {
    return ['gpt-4o'].includes(model);
};
export const defaultPromptOptions = {
    model: 'eu.anthropic.claude-3-5-sonnet-20240620-v1:0',
    temperature: 0.2,
};
export class Prompt {
    constructor(messages = [], options = defaultPromptOptions, variables = {}) {
        Object.defineProperty(this, "messages", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: messages
        });
        Object.defineProperty(this, "options", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: options
        });
        Object.defineProperty(this, "variables", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: variables
        });
    }
    model(model) {
        return this.withOption('model', model);
    }
    temp(temperature) {
        return this.withOption('temperature', temperature);
    }
    system(content) {
        return this.add(new SystemMessage({ content }));
    }
    ai(content) {
        return this.add(new AIMessage({ content }));
    }
    human(content) {
        return this.add(new HumanMessage({ content }));
    }
    add(message) {
        return new Prompt([...this.messages, message], this.options);
    }
    withPredictionOutput(output) {
        return new Prompt(this.messages, Object.assign(Object.assign({}, this.options), { predictionOutput: output }), Object.assign({}, this.variables));
    }
    withOption(option, value) {
        return new Prompt(this.messages, Object.assign(Object.assign({}, this.options), { [option]: value }));
    }
    withVariables(variables) {
        return new Prompt(this.messages, this.options, Object.assign(Object.assign({}, this.variables), variables));
    }
    replaceVariables(content) {
        if (typeof content === 'string') {
            return content.replace(/%([a-zA-Z0-9_]+)%/g, (match, varName) => {
                var _a;
                return (_a = this.variables[varName]) !== null && _a !== void 0 ? _a : match;
            });
        }
        //TODO: handle complex content
        return '';
    }
    getMessages() {
        return this.messages.map(message => this.messageWithDynamicContent(message));
    }
    messageWithDynamicContent(message) {
        const that = this;
        return new Proxy(message, {
            get(target, prop, receiver) {
                if (prop === 'content') {
                    return that.replaceVariables(target.content);
                }
                return Reflect.get(target, prop, receiver);
            },
        });
    }
}
export const emptyPrompt = new Prompt();
//# sourceMappingURL=Prompt.js.map